import React from 'react';

export const VehicleDocumentsIcon = () => (
  <svg height="25.75" viewBox="0 0 23 25.75" width="23" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m57.5 296.5v11a2.75 2.75 0 0 0 2.75 2.75h8.25m-11-13.75v-2.75a2.75 2.75 0 0 1 2.75-2.75h6.305a1.373 1.373 0 0 1 .972.4l6.07 6.069a1.377 1.377 0 0 1 .4.972v9.059a2.75 2.75 0 0 1 -2.75 2.75h-2.747m-11-13.75h-2.75a2.75 2.75 0 0 0 -2.75 2.75v13.75a2.75 2.75 0 0 0 2.75 2.75h11a2.75 2.75 0 0 0 2.75-2.75v-2.75"
      fill="none"
      stroke="#0a3256"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(-51.5 -290.5)"
    />
  </svg>
);
